import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseHttpService } from '@shared/services/base-http.service';
import { Tag } from '@shared/interfaces/project/tag.interface';
import { ProjectPublish } from '@shared/interfaces/project/project.interface';
import { Project } from '@shared/models/project.model';
import { UploadImg } from '@shared/interfaces/project/upload-img.interface';
import { Response } from '@shared/models/response.model';
import { SuccessRes } from '@shared/interfaces/success-res.interface';
import { Coordinates } from '@shared/interfaces/project/coordinates.interface';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  constructor(public baseHttp: BaseHttpService) {}

  tagList(): Observable<Response<Tag[]>> {
    return this.baseHttp.get('/parameters/tags').pipe(map((resp) => resp as Response<Tag[]>));
  }

  enabledTagList(): Observable<Response<Tag[]>> {
    return this.baseHttp
      .get('/parameters/enabled-tags')
      .pipe(map((resp) => resp as Response<Tag[]>));
  }

  getCoordinates(): Observable<Response<Coordinates>> {
    return this.baseHttp
      .get('/parameters/get-ip-coords')
      .pipe(map((resp) => resp as Response<Coordinates>));
  }

  newProject(pack: Project): Observable<Response<Project>> {
    return this.baseHttp
      .put('/project', { project: pack })
      .pipe(map((resp) => resp as Response<Project>));
  }

  editProject(pack: Project, id: number): Observable<Response<Project>> {
    return this.baseHttp
      .post('/project/' + id, { project: pack })
      .pipe(map((resp) => resp as Response<Project>));
  }

  publishProject(pack: ProjectPublish, id: number): Observable<Response<Project>> {
    return this.baseHttp
      .post('/project/' + id + '/update-status', pack)
      .pipe(map((resp) => resp as Response<Project>));
  }

  updateImgData(pack: UploadImg, id: number): Observable<Response<Project>> {
    return this.baseHttp
      .post('/files/' + id, { file: { meta_data: pack.data } })
      .pipe(map((resp) => resp as Response<Project>));
  }

  uploadImg(pack: UploadImg): Observable<SuccessRes> {
    return this.baseHttp
      .postQueue('/files/project/' + pack.id + '/' + pack.container, pack.imgData)
      .pipe(map((resp) => resp as SuccessRes));
  }
}
